import { getRouteApi, useNavigate } from "@tanstack/react-router";
import { useEnterpriseStore } from "../state/enterpriseStore";

type FacilityDrawerTab = "overview" | "maturity" | "value" | "achievements";

const appRouteApi = getRouteApi("/_app");

export function useOpenFacilityDrawer() {
  const navigate = useNavigate();
  const routeExternalCustomerId = appRouteApi.useSearch({
    select: (search) => search.externalCustomerId,
  });
  const storedExternalCustomerId = useEnterpriseStore(
    (state) => state.externalCustomerId,
  );

  return (facilityId: number, tab?: FacilityDrawerTab) => {
    const externalCustomerId =
      routeExternalCustomerId ?? storedExternalCustomerId;

    void navigate({
      to: ".",
      resetScroll: false,
      search: (prev) => {
        const next: Record<string, unknown> = {
          ...(prev as Record<string, unknown>),
          externalCustomerId: externalCustomerId ?? undefined,
          facilityId,
        };

        if (tab === undefined) {
          delete next.tab;
        } else {
          next.tab = tab;
        }

        return next;
      },
    });
  };
}
